/* eslint-disable @typescript-eslint/no-explicit-any */
type ObjectWithAnyProperties = {
  [key: string]: any;
};

export const mergeConfig = (
  defaultObj: ObjectWithAnyProperties,
  actualObj: ObjectWithAnyProperties,
): ObjectWithAnyProperties => {
  const resultMap: ObjectWithAnyProperties = {};

  for (const key in defaultObj) {
    if (Object.prototype.hasOwnProperty.call(defaultObj, key)) {
      const isBothObjects =
        typeof defaultObj[key] === 'object' &&
        typeof actualObj[key] === 'object' &&
        !Array.isArray(actualObj[key]);

      if (isBothObjects) {
        if (
          key === 'routeParams' ||
          key === 'queryString' ||
          key === 'requestHeaders' ||
          key === 'errorMessages'
        ) {
          resultMap[key] = { ...defaultObj[key], ...actualObj[key] };
        } else {
          resultMap[key] = mergeConfig(defaultObj[key], actualObj[key]);
        }
      } else {
        resultMap[key] = Object.prototype.hasOwnProperty.call(actualObj, key)
          ? actualObj[key]
          : defaultObj[key];
      }
    }
  }

  return resolveDynamicValues(resultMap, resultMap);
};

const resolveDynamicValues = (
  obj: ObjectWithAnyProperties,
  resultMap: ObjectWithAnyProperties,
): ObjectWithAnyProperties => {
  for (const key in obj) {
    if (obj[key] && typeof obj[key] === 'object') {
      if (key === 'queryString') {
        if (obj[key].tenant === '' && resultMap.tenantId) {
          obj[key].tenant = resultMap.tenantId;
        }
        if (obj[key].tenantId === '' && resultMap.tenantId) {
          obj[key].tenantId = resultMap.tenantId;
        }
      }

      obj[key] = resolveDynamicValues(obj[key], resultMap);
    }
  }
  return obj;
};

export const removeEmpty = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      removeEmpty(obj[key]);
    } else if (obj[key] === undefined) {
      delete obj[key];
    }
  });

  return obj;
};
